import React from "react"
import styled from "styled-components"
import BackgroundImage from "../images/footer.svg"
import { Card, CardContent } from "@material-ui/core"
import { Link } from "gatsby"
import { withTranslation } from "react-i18next"
import withSimpleErrorBoundary from "../util/withSimpleErrorBoundary"

import UHLogo from "../images/uh-logo.png"
import MoocfiLogo from "../images/moocfi-logo-bw.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTwitter,
  faFacebook,
  faYoutube,
  faGithub,
} from "@fortawesome/free-brands-svg-icons"

const StyledIcon = styled(FontAwesomeIcon)`
  color: black;
  margin-bottom: 1rem;
  margin: 1rem;
`

const SocialContainer = styled.div``

const ContentContainer = styled.div`
  padding: 1rem 0;
`

const GithubContainer = styled.div`
  padding-top: 1rem;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const FooterWrapper = styled.footer`
  height: 35rem;
  position: relative;
  a {
    color: #006fe6;
  }
`

const FooterBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-image: url(${BackgroundImage});
  z-index: 0;
`

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

const StyledCard = styled(Card)`
  width: 90%;
  max-width: 800px;
  background-color: white;
  z-index: 1;
`

const StyledCardContent = styled(CardContent)`
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
`

const BrandsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  img {
    height: 6rem;
    width: auto;
    margin: 1rem;
  }
`

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.t = this.props.t
  }
  render() {
    return (
      <FooterWrapper>
        <FooterBackground />
        <FooterContent>
          <StyledCard>
            <StyledCardContent>
              <GithubContainer>
                <a
                  href="https://github.com/rage/cyber-security-base-19"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StyledIcon
                    icon={faGithub}
                    size="3x"
                    title={this.t("footer-src")}
                  />
                  <div>{this.t("footer-src")}</div>
                </a>
              </GithubContainer>
              <ContentContainer>
                {this.t("makers")}{" "}
                <a
                  href="https://www.helsinki.fi/en/researchgroups/data-driven-education"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.t("rage")}
                </a>
                .
              </ContentContainer>

              <ContentContainer>
                <Link to="/credits">{this.t("credits")}</Link>.
              </ContentContainer>
              <SocialContainer>
                <a
                  href="https://twitter.com/moocfi"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={this.t("twitter-aria")}
                >
                  <StyledIcon icon={faTwitter} size="3x" />
                </a>
                <a
                  href="https://www.facebook.com/Moocfi"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={this.t("facebook-aria")}
                >
                  <StyledIcon icon={faFacebook} size="3x" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCkHoQ5p9skFdyjrV3_tnUrA"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={this.t("facebook-aria")}
                >
                  <StyledIcon icon={faYoutube} size="3x" />
                </a>
              </SocialContainer>
              <BrandsContainer>
                <a
                  href="https://helsinki.fi"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img alt="Helsingin yliopisto" src={UHLogo} />
                </a>
                <a
                  href="https://mooc.fi"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img alt="MOOC.fi" src={MoocfiLogo} />
                </a>
              </BrandsContainer>
            </StyledCardContent>
          </StyledCard>
        </FooterContent>
      </FooterWrapper>
    )
  }
}

export default withTranslation("common")(withSimpleErrorBoundary(Footer))
